import type { Feature } from './feature'

export class Selectors {
  /** Whether the processes slideout is open. */
  public readonly isSlideoutOpen

  constructor(feature: Feature) {
    this.isSlideoutOpen = feature.state.project(state => state.isSlideoutOpen)
  }
}
